import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useDocumentTitle } from "@/lib/hooks/use-document-title";
import { useAuth } from "@/features/auth/auth-provider";
import { getControlPlaneRuntimeConfig } from "@/app/runtime-config";

export function SettingsPage() {
  const runtimeConfig = getControlPlaneRuntimeConfig();
  const baseUrl = runtimeConfig.apiBaseUrl || window.location.origin;
  const { user, tenant, roles } = useAuth();
  useDocumentTitle("Settings");

  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-lg font-semibold" style={{ color: "var(--text-strong)" }}>Settings</h1>

      {/* API Configuration */}
      <Card>
        <CardHeader>
          <CardTitle>API Configuration</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2 text-xs">
              <span className="font-medium" style={{ color: "var(--text-strong)" }}>Base URL</span>
              <code
                className="px-2 py-1 rounded-[var(--radius-sm)] font-mono text-xs"
                style={{ background: "var(--bg-accent)", color: "var(--muted-foreground)" }}
              >
                {baseUrl}
              </code>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Authentication */}
      <Card>
        <CardHeader>
          <CardTitle>Authentication</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2 text-xs">
              <span className="font-medium" style={{ color: "var(--text-strong)" }}>Mode</span>
              <span style={{ color: "var(--muted-foreground)" }}>
                Server-managed OIDC cookie
              </span>
            </div>
            <p className="text-[10px]" style={{ color: "var(--muted-foreground)" }}>
              Authentication is delegated to the server. The browser does not store access or refresh tokens.
            </p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Session</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-2 text-xs">
            <div className="flex items-center gap-2">
              <span className="font-medium" style={{ color: "var(--text-strong)" }}>User</span>
              <span style={{ color: "var(--muted-foreground)" }}>
                {user?.displayName ?? "Not signed in"}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-medium" style={{ color: "var(--text-strong)" }}>Tenant</span>
              <span style={{ color: "var(--muted-foreground)" }}>
                {tenant?.displayName ?? "No tenant"}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-medium" style={{ color: "var(--text-strong)" }}>Roles</span>
              <span style={{ color: "var(--muted-foreground)" }}>
                {roles.length > 0 ? roles.join(", ") : "None"}
              </span>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* About */}
      <Card>
        <CardHeader>
          <CardTitle>About</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-1 text-xs">
            <div className="flex items-center gap-2">
              <span className="font-medium" style={{ color: "var(--text-strong)" }}>Application</span>
              <span style={{ color: "var(--muted-foreground)" }}>OpenClaw Control</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-medium" style={{ color: "var(--text-strong)" }}>Version</span>
              <span style={{ color: "var(--muted-foreground)" }}>0.0.0</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
